$(function() {
  'use strict';
  
  $(".slide-link").each(function() {
    
    var $slide_link = $(this);
    var $target_carousel  = $("#" + $slide_link.data("carousel-id"));
    
    if($target_carousel.length === 0) {
      return;
    }
    
    var $target_slide_index = parseInt($slide_link.data("slide-index"));
    var $trigger_style = (typeof $slide_link.data("trigger-style") !== 'undefined' ? $slide_link.data("trigger-style") : "both"); //"both", "hover", "click" 
    var $parent_row_trigger = (typeof $slide_link.data("parent-row-trigger") !== 'undefined' ? ($slide_link.data("parent-row-trigger") === "true" || $slide_link.data("parent-row-trigger") === true ? true : false) : false); //"true", "false"
    
    var $toggle_id = (typeof $slide_link.data("toggle-id") !== 'undefined' ? $slide_link.data("toggle-id") : false);
    var $toggle = $toggle_id !== false ? $("#" + $toggle_id) : false;
            
    var $trigger_action;
    switch ($trigger_style) {
      case "both":
          $trigger_action = "mouseover focus click";
          break;
      case "click":
          $trigger_action = "click";
          break;
      case "hover":
        $trigger_action = "mouseover";
        break;   
    }
    
    var $triggered = false;
    var $trigger = $slide_link;

    if($parent_row_trigger) {
      $trigger = slick_slide_link_find_parent_row($slide_link);  
    }
    
    $trigger.on($trigger_action, function() {
      $('.slide-link').removeClass('active');
      $(this).addClass('active');
      if($toggle) {
        
        // Separate to this plugin, when a toggle contains a slick carousel, the carousel needs to be reinitialised on carousel open
        // We then hook into the "reInit" event for the toggle, and change the slide
        $target_carousel.on("reInit", function() {
          if(!$triggered && ($target_carousel.slick('slickCurrentSlide') !== $target_slide_index)) {
            $triggered = true;
            $target_carousel.slick('slickGoTo', $target_slide_index);
          }
        });
                    
        // Open the toggle, then (if you've correctly setup the carousel reinit elsewhere in your code) the above reInit event hook will run
        $toggle.foundation('toggle'); 
        
      } else {
        
        if(!$triggered && ($target_carousel.slick('slickCurrentSlide') !== $target_slide_index)) {
          $triggered = true;
          $target_carousel.slick('slickGoTo', $target_slide_index);
        }
        
      }
    });
    
    // After the slide has changed
    $target_carousel.on('afterChange', function(event, slick, currentSlide, nextSlide){
      $triggered = false;
    });

  });
 
  
  function slick_slide_link_find_parent_row($slide_link) {
    
    var $parent_row = $slide_link.closest("td").parent();
    
    if($parent_row.length) {
      return $parent_row;
    } else {
      return $slide_link;
    }
    
  }
  
});